import { render, staticRenderFns } from "./CompanySearchResult.vue?vue&type=template&id=6beb7b68&scoped=true&"
import script from "./CompanySearchResult.vue?vue&type=script&lang=ts&"
export * from "./CompanySearchResult.vue?vue&type=script&lang=ts&"
import style0 from "./CompanySearchResult.vue?vue&type=style&index=0&id=6beb7b68&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6beb7b68",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {CompanyAvatar: require('/root/project/frontend/src/components/CompanyAvatar.vue').default})
